import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { isObject } from '@icc/shared/helpers/b2b';
import { ConfigService } from '@icc/shared';

export class TranslateHttpLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private domSanitizer: DomSanitizer,
        private configService: ConfigService,
    ) {}

    /**
     * Gets the translations from the server
     */
    public getTranslation(lang: string): Observable<any> {
        const project = this.configService.config?.projectName || 'icc';
        const timestamp = this.configService.config?.translationsTimestamp || 0;
        return this.http.get<Record<string, Record<string, string> | string>>(
            `${window.location.origin}/translations/${lang ?? 'pl'}.${project}.json?timestamp=${timestamp}`
        );
    }

    public sanitize(values: Record<string, Record<string, string> | string>) {
        const newValues: Record<string, Record<string, string> | string> = {};
        for (const key in values) {
            const value = values[key];
            const sanitizedKey = key.replace(/\\/g, '').replace(/\\$/, '');
            if (isObject(value)) {
                const newValues2: Record<string, string> = {};
                for (const key2 in value) {
                    newValues2[key2.replace(/\\/g, '').replace(/\\$/, '')] = value[key2]
                        .replace(/\\/g, '')
                        .replace(/\\$/, '');
                }
                newValues[sanitizedKey] = newValues2;
            } else {
                newValues[sanitizedKey] = value.replace(/\\/g, '').replace(/\\$/, '');
            }
        }
        return newValues;
    }
}
